import Command from '@ckeditor/ckeditor5-core/src/command';
import { Writer } from '@ckeditor/ckeditor5-core/src/editor';
import { addEmptyParagraphAfterPlugin } from '../utils';

interface CommandOptions {
  paneltype: string;
}

function createInfoPanel(writer: Writer, paneltype: string) {
  const infoPanel = writer.createElement('infoPanel', { paneltype });
  const infoPanelDescription = writer.createElement('infoPanelDescription');

  writer.append(infoPanelDescription, infoPanel);
  writer.appendElement('paragraph', infoPanelDescription);

  return infoPanel;
}

export class InsertInfoPanelCommand extends Command {
  execute(options: CommandOptions) {
    const { paneltype } = options;

    this.editor.model.change((writer) => {
      const infoPanelNode = createInfoPanel(writer, paneltype);

      this.editor.model.insertContent(infoPanelNode);

      addEmptyParagraphAfterPlugin(this.editor, writer, infoPanelNode);

      this.editor.editing.view.focus();
      writer.setSelection(writer.createPositionAt(infoPanelNode, 1));
    });
  }

  refresh() {
    const { model } = this.editor;
    const { selection } = model.document;
    const allowedIn = model.schema.findAllowedParent(
      selection.getFirstPosition(),
      'infoPanel',
    );

    this.isEnabled = allowedIn !== null;
  }
}
